import { Type } from "@sinclair/typebox";
import { Device } from "./device";
import { User } from "./user";
import { Nullable, NullableString } from "../../../utils/typeboxTypes";
export const RecipientType = Type.Union([
    Type.Literal("agent"),
    Type.Literal("chatbot"),
    Type.Literal("user"),
]);
export const BaseRecipient = Type.Object({
    /**
     * The device the recipient is using, this will determine how notifications are sent.
     */
    device: Type.Optional(Nullable(Device)),
    /**
     * Was the recipient the author of the message.
     */
    is_author: Type.Boolean(),
    /**
     * Date and time of when the the recipient was sent the message.
     */
    sent_at: Type.Optional(NullableString),
    /**
     * Date and time of when the the recipient was delivered the message.
     */
    delivered_at: Type.Optional(NullableString),
    /**
     * Date and time of when the the recipient read the message.
     */
    read_at: Type.Optional(NullableString),
    /**
     * The avatar URL of the recipient.
     */
    avatar_id: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
    /**
     * Locale for the recipient
     */
    locale: Type.Optional(Type.String()),
}, {
    title: "BaseRecipient",
});
export const AgentRecipient = Type.Composite([
    User,
    BaseRecipient,
    Type.Object({
        type: Type.Literal("agent"),
    }, {
        title: "AgentRecipient",
    }),
]);
export const ChatbotRecipient = Type.Composite([
    BaseRecipient,
    Type.Object({
        type: Type.Literal("chatbot"),
        name: Type.String(),
        revisionId: Type.Optional(Type.Union([Type.Number(), Type.Null()])),
        backgroundColor: Type.Optional(Type.Union([Type.String(), Type.Null()])),
        iconImageFileId: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    }, {
        title: "ChatbotRecipient",
    }),
]);
export const UserRecipient = Type.Composite([
    User,
    BaseRecipient,
    Type.Object({
        type: Type.Literal("user"),
        device: Device,
        unreadCount: Type.Optional(Type.Number()),
    }, {
        title: "UserRecipient",
    }),
]);
export const Recipient = Type.Union([AgentRecipient, ChatbotRecipient, UserRecipient]);
